import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Footer.css";

export default function Footer() {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const handleLanguageChange = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    <footer className="site-footer" aria-label={t("a11y_footer")}>
      <div style={{ marginBottom: "10px" }}>
        <div className="footer-brand">MindBlows.com</div>

        <div className="footer-links">
          <Link to="/">{t("home")}</Link>
          <Link to="/apps">{t("apps")}</Link>
          <Link to="/about">{t("about")}</Link>
        </div>

        <div className="footer-links">
          <Link to="/privacy-policy">{t("privacy_policy")}</Link>
          <Link to="/terms">{t("terms")}</Link>
          <Link to="/support">{t("support")}</Link>
          <Link to="/accessibility">{t("accessibility")}</Link>
          <Link to="/ads-api">{t("ads_api")}</Link>
        </div>
      </div>

      <div className="footer-social">
        <a
          href="https://www.facebook.com/MindBlowsStudio"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/assets/icons/facebook.svg"
            alt="Facebook"
            width={24}
            height={24}
          />
        </a>
        <a
          href="https://www.instagram.com/mindblowsstudio/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/assets/icons/instagram.svg"
            alt="Instagram"
            width={24}
            height={24}
          />
        </a>
        <a
          href="https://apps.apple.com/lu/developer/sivan-gants/id1241647691"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/assets/icons/apple.svg"
            alt="App Store"
            width={24}
            height={24}
          />
        </a>
        <a
          href="https://play.google.com/store/apps/dev?id=6936898117969072451"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/assets/icons/googleplay.svg"
            alt="Google Play"
            width={24}
            height={24}
          />
        </a>
      </div>

      <label className="lang-label">
        <span className="visually-hidden">{t("a11y_language")}</span>
        <select
          onChange={handleLanguageChange}
          value={i18n.language?.startsWith("he") ? "he" : "en"}
          className="lang-dropdown"
          aria-label={t("a11y_language")}
        >
          <option value="en">English</option>
          <option value="he">עברית</option>
        </select>
      </label>

      <div className="footer-copy">
        © {new Date().getFullYear()} {t("trademark")}
      </div>
    </footer>
  );
}
